import React from "react";
import clsx from "clsx";

import { Modal, Card } from "@material-ui/core";

import { CardHeader, CardActions, CardContent, Grid } from "@material-ui/core";

import { alertAction, typeAlert } from "constants/globals";

import { useStyles, getModalStyle } from "./style";

type TypeResponse = {
  action: string;
  fieldValue: string;
};

type Props = {
  open: boolean;
  type: string;
  title: string;
  message: string;
  handleClose: () => void;
  emitter: (data: TypeResponse) => void;
  sizeOverride: number;
};

const Alert = ({ open, type, title, message, handleClose, emitter, sizeOverride }: Props) => {
  const classes = useStyles();

  const [modalStyle] = React.useState(getModalStyle(sizeOverride && sizeOverride > 50 ? sizeOverride : 50));

  const handleConfirmAlert = () => {
    const response = {
      action: alertAction.CONFIRM,
      fieldValue: "",
    };
    sendData(response);
  };

  const handleCancelAlert = () => {
    const response = {
      action: alertAction.CANCEL,
      fieldValue: "",
    };
    sendData(response);
  };

  const sendData = (response: TypeResponse) => {
    emitter(response);
  };

  const InnerBody = () => {
    switch (type) {
      case typeAlert.CONFIRMATION:
        return (
          <>
            <CardContent className={classes.content}>
              <Grid container alignContent="center" justify="center" direction="row">
                <span className={classes.message}>{message}</span>
              </Grid>
            </CardContent>
            <CardActions>
              <Grid container spacing={2} alignContent="center" justify="center" direction="row">
                <button onClick={handleConfirmAlert} className={clsx(classes.button, classes.buttonAccept)}>
                  Aceptar
                </button>
                <button onClick={handleCancelAlert} className={clsx(classes.button, classes.buttonCancel)}>
                  Cancelar
                </button>
              </Grid>
            </CardActions>
          </>
        );
      default:
        return <div></div>;
    }
  };

  const body = (
    <Card style={modalStyle} className={classes.card}>
      <CardHeader title={title} classes={{ title: classes.header }} />
      <InnerBody />
    </Card>
  );

  return (
    <Modal disableBackdropClick open={open} onClose={handleClose}>
      {body}
    </Modal>
  );
};

export default Alert;
